// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './store/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'animate.css'
import '@/assets/scss/normalize.scss'
import '@/assets/icon/style.css'
// import '@/../static/icon/style.css'
import '@/assets/scss/color.scss'
import '@/assets/scss/ly.scss'
import '@/assets/scss/main.scss'
Vue.use(VueAwesomeSwiper /* { default global options } */)

Vue.use(Vuex)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js